module.exports = __webpack_public_path__ + "static/img/logo_2.3966cd9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/logo_2.png
// module id = 1vYc
// module chunks = 1